export const QF_MESSENGER_AUDIENCE = 'https://interkwam.rhodium24.io/messenger'
export const QF_MESSENGER_SCOPE = 'openid profile email'

const supportOrigin = (() => {
  if (import.meta.env.VITE_ENVIRONMENT === 'uat') {
    return 'https://support-uat.quotationfactory.com'
  }

  if (import.meta.env.DEV || import.meta.env.VITE_ENVIRONMENT === 'dev') {
    return 'https://support-dev.quotationfactory.com'
  }

  return 'https://support.quotationfactory.com'
})()

const loaderId = 'qf-messenger-loader'

export const loadQFMessenger = () => {
  if (!window.QFMessenger) {
    const messenger: QFMessengerCommand = (...args: unknown[]) => {
      messenger.q = messenger.q || []
      messenger.q.push(args)
    }
    window.QFMessenger = messenger
  }

  if (!document.getElementById(loaderId)) {
    const script = document.createElement('script')
    script.id = loaderId
    script.async = true
    script.src = `${supportOrigin}/messenger/widget/loader.js`
    document.head.appendChild(script)
  }
}

const auth0ErrorCode = (error: unknown) => {
  if (typeof error !== 'object' || error === null) return undefined

  const value = error as { error?: string; code?: string }
  return value.error || value.code
}

export const reportMessengerTokenError = (error: unknown) => {
  const code = auth0ErrorCode(error)
  const rawMessage = error instanceof Error ? error.message : String(error)
  let message: string

  if (code === 'consent_required') {
    message = `Auth0 consent_required: the Auth0 tenant has not granted this user/application consent for API audience ${QF_MESSENGER_AUDIENCE} and scopes ${QF_MESSENGER_SCOPE}. Configure the API permissions and grant consent in Auth0.`
  } else if (code === 'login_required') {
    message = `Auth0 login_required: no Auth0 end-user session is available for silent token acquisition. Verify the application session and that this web origin is listed in the Auth0 application's Allowed Web Origins.`
  } else if (
    rawMessage.toLowerCase().includes('audience') ||
    code === 'unauthorized_client' ||
    code === 'access_denied'
  ) {
    message = `Auth0 audience configuration error: verify that an Auth0 API with identifier ${QF_MESSENGER_AUDIENCE} exists in the tenant and that this SPA application is authorized to request it.`
  } else {
    message = `Unable to obtain the Auth0 end-user token for Messenger: ${rawMessage}`
  }

  console.error(message)
  window.dispatchEvent(
    new CustomEvent<QFMessengerErrorDetail>('qf-messenger-error', {
      detail: { message },
    }),
  )
}
